import script from "./MessageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageItem.vue?vue&type=script&setup=true&lang=js"

import "@/features/message/styles/MessageItem.css?vue&type=style&index=0&id=5435acac&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5435acac"]])

export default __exports__